<template>
    <div class="claim-chat">
        <div class="messages-wrap">
            <div v-if="loading" class="loading-state">
                <strong>Загрузка сообщений...</strong>
            </div>
            <div v-else-if="messages.length === 0" class="no-messages">
                <strong>Нет сообщений</strong>
            </div>
            <div v-else class="messages">
                <div v-for="message in messages" :key="message.id" class="message" :class="{ 'from-manager': message.isFromManager }">
                    <div class="message-header">
                        <span class="date">{{ formatDate(message.createdAt) }}</span>
                        <span class="author" v-if="message.isFromManager">Ответ претензиониста</span>
                    </div>
                    <div class="message-text">{{ message.messageText }}</div>
                    <div class="message-footer" v-if="!message.isFromManager">
                        Ваше сообщение передано в отдел претензий
                    </div>
                </div>
            </div>
        </div>
        <div class="chat-attachments" v-if="files.length">
            <div v-for="(file, key) in files" :key="key" class="attachment">
                <span class="attach-name">{{file.name}}</span>
                <span class="btn-remove" title="Удалить" @click="removeAttachment(file)"></span>
            </div>
        </div>
        <div class="message-input">
            <div class="attach-btn" @click="addAttachments" title="Прикрепить файлы">
                <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"></path></svg>
            </div>
            <input type="file" ref="files" multiple @change="handleFilesUpload" style="display:none"/>
            <textarea
                v-model="newMessage"
                placeholder="Введите ваше сообщение..."
                :disabled="sending"
                @keydown.enter.ctrl="sendMessage"
                @keydown.enter.meta="sendMessage"
            ></textarea>
            <button
                class="button"
                type="confirm"
                :disabled="sending || (!newMessage.trim() && files.length === 0)"
                @click="sendMessage"
            >
                {{ sending ? 'Отправка...' : 'Отправить' }}
            </button>
        </div>
    </div>
</template>

<script>
import claimChatService from '@/services/claimChatService'

export default {
    props: ['claimId'],
    data() {
        return {
            messages: [],
            newMessage: '',
            files: [],
            loading: false,
            sending: false,
            error: null,
            pollInterval: null
        }
    },
    methods: {
        formatDate(date) {
            return this.moment(date).format('DD.MM.YYYY HH:mm')
        },
        async fetchMessages() {
            try {
                this.loading = true
                this.messages = await claimChatService.getMessages(this.claimId)
                this.loading = false
                this.scrollToBottom()
                await this.markMessagesAsRead()
            }
            catch (error) {
                this.error = error.message
                this.loading = false
            }
        },
        async sendMessage() {
            if (!this.newMessage.trim() && this.files.length === 0) return

            try {
                this.sending = true
                await claimChatService.sendMessage(this.claimId, this.newMessage, this.files)
                this.newMessage = ''
                this.files = []
                await this.fetchMessages()
                this.sending = false
            }
            catch (error) {
                this.error = error.message
                this.sending = false
            }
        },
        removeAttachment (file) {
            var index = this.files.indexOf(file);
            if (index !== -1) {
                this.files.splice(index, 1);
            }
        },
        addAttachments () {
            this.$refs.files.value = null;
            this.$refs.files.click();
        },
        handleFilesUpload () {
            const files = this.$refs.files.files;
            if (files && files.length) {
                for (var i = 0; i < files.length; i++) {
                    this.files.push(files[i]);
                }
            }
            this.$refs.files.value = null;
        },
        async markMessagesAsRead() {
            try {
                await claimChatService.markAsRead(this.claimId)
            }
            catch (error) {
                this.error = error.message
            }
        },
        scrollToBottom() {
            this.$nextTick(() => {
                const container = this.$el.querySelector('.messages')
                if (container) {
                    container.scrollTop = container.scrollHeight
                }
            })
        },
        startPolling() {
            this.pollInterval = setInterval(async () => {
                try {
                    const messages = await claimChatService.getMessages(this.claimId)
                    this.messages = messages
                }
                catch (error) {
                    this.error = error.message
                }
            }, 30000)
        },
        stopPolling() {
            if (this.pollInterval) {
                clearInterval(this.pollInterval)
                this.pollInterval = null
            }
        }
    },
    async mounted() {
        await this.fetchMessages()
        this.startPolling()
    },
    beforeDestroy() {
        this.stopPolling()
    }
}
</script>

<style lang="scss">
    @import "../../assets/styles/components/claim-chat.scss";
</style>
